module.exports = __webpack_public_path__ + "assets/img/Type E (61).091329c4.jpg";